// extracted by mini-css-extract-plugin
module.exports = {"primary":"BuySection_primary__0e2jL primaryButton","rainbow":"BuySection_rainbow__fb8z5","colorRotate":"BuySection_colorRotate__EPxFm"};